export default "__VITE_ASSET__Bd_1KLgd__"